import axios from "axios";

export default {
  namespaced: true,
  state: {
    rivalesData: null
  },
  mutations: {
    setRivalesData(state, data) {
      state.rivalesData = data;
    }
  },
  actions: {
    async fetchRivalesData({ state, commit }) {
      if (state.rivalesData) return state.rivalesData;
      const response = await axios.get("/api/games/rivals/getWinsAndLossesByRival");
      commit("setRivalesData", response.data);
      return response.data;
    }
  }
}